import React from 'react';

const SkillCard = ({ title, tools, children }) => {
  return (
    <div
      data-aos-easing="ease-in-out"
      data-aos="zoom-in"
      className="mc-panel flex flex-col items-center p-6 text-white transition-all duration-300 hover:-translate-y-2 hover:border-[#ffff55] hover:shadow-[0_0_20px_rgba(255,255,85,0.25)] group"
    >
      {/* Icon / Header */}
      <div className="mc-slot w-14 h-14 flex items-center justify-center p-2.5 mb-4 text-[#ffff55] select-none transition-all duration-300 group-hover:scale-110 group-hover:bg-[#444] group-hover:border-[#ffff55] group-hover:shadow-[0_0_10px_rgba(255,255,85,0.4)]">
        {children}
      </div>

      {/* Title */}
      <h2 className="pb-6 text-2xl font-bold tracking-wider text-[#ffff55] uppercase select-none transition-colors duration-300 group-hover:text-white">{title}</h2>

      {/* Tool Icons / Labels */}
      <div className="flex flex-wrap justify-center gap-3 w-full">
        {tools.map((tool, index) => 
          typeof tool === "string" ? (
            <span
              key={index}
              className="mc-slot px-3 py-1.5 text-md font-bold uppercase text-[#ffff55] transition-all duration-200 hover:scale-110 hover:bg-[#5c5c5c] hover:text-[#55ff55] hover:border-[#55ff55] hover:shadow-[0_0_8px_rgba(85,255,85,0.3)] cursor-default"
            >
              {tool}
            </span>
          ) : (
            <div 
              key={tool.id} 
              className="mc-slot flex items-center gap-2.5 px-3 py-2 text-md text-white font-bold uppercase select-none transition-all duration-200 hover:scale-110 hover:bg-[#5c5c5c] hover:text-[#ffff55] hover:border-[#ffff55] hover:shadow-[0_0_8px_rgba(255,255,85,0.3)] cursor-default"
            >
              <img 
                alt={tool.alt} 
                src={tool.img} 
                className="w-6 h-6 object-contain transition-transform duration-200 group-hover:rotate-6"
              />
              <span>{tool.alt}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default SkillCard;

